// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"365177f9","239":"ea2a7828","453":"d019e20f","732":"6047cad7"}[chunkId] + ".chunk.js";
};